'use strict';
var app = require('angular');

app.module('ngLocale', [], ['$provide', require('./es-us')]);
